<template>
    <div id="mealplan-container">
        <div class="mealplan-day">
            <div v-for="day in 7" :key="'day' + day">
                <div class="sticky" :class="{inline: inline}" >
                    <h5 :class="{ today: (currentWeek - 1) * 7 + day - 1 === currentDay }">{{ day | dayName(currentWeek, (realDay + 1)) }}</h5>
                    <div class="nutrition-info">
                        <div class="nutrition-results">
                            <p>
                                <span>{{ day_nutrition((currentWeek - 1) * 7 + day, 'calories') }}</span>
                                <span>cal</span>
                            </p>
                        </div>
                        <div class="nutrition-results">
                            <p>
                                <span>{{ day_nutrition((currentWeek - 1) * 7 + day, 'protein') }}g</span>
                                <span>protein</span>
                            </p>
                        </div>
                        <div class="nutrition-results">
                            <p>
                                <span>{{ day_nutrition((currentWeek - 1) * 7 + day, 'total_fat') }}g</span>
                                <span>fat</span>
                            </p>
                        </div>
                        <div class="nutrition-results">
                            <p>
                                <span>{{ day_nutrition((currentWeek - 1) * 7 + day, 'carbs') }}g</span>
                                <span>carbs</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="meal" v-for="meal_type in meal_types" :key="meal_type.id">
                    <div class="meal-image">
                        <img v-if="meal(currentWeek, day, meal_type.id) && meal(currentWeek, day, meal_type.id).recipe && meal(currentWeek, day, meal_type.id).recipe.image" :src="imageUrl + '/images/recipe_images/thumb_' + meal(currentWeek, day, meal_type.id).recipe.image" alt="image"/>
                        <img v-else-if="meal(currentWeek, day, meal_type.id) && meal(currentWeek, day, meal_type.id).meal && meal(currentWeek, day, meal_type.id).meal.image" :src="imageUrl + '/images/meal_images/thumb_' + meal(currentWeek, day, meal_type.id).meal.image" alt="image"/>
                        <img v-else :src="getMealIcon(meal_type)" alt="image"/>
                    </div>
                    <div class="meal-details">
                        <div class="meal-name">
                            <h6>{{ meal_type.title }}</h6>
                        </div>
                        <div class="meal-description" v-if="meal(currentWeek, day, meal_type.id) && (meal(currentWeek, day, meal_type.id).recipe || meal(currentWeek, day, meal_type.id).meal)">
                            <v-btn v-if="!inline" text icon right bottom style="float: right" class="ma-0" @click="updateMealToken(meal(currentWeek, day, meal_type.id))" :disabled="cantClaimToken(meal(currentWeek, day, meal_type.id))">
                                <v-icon class="token-color" :class="{'token-claimed': meal(currentWeek, day, meal_type.id).claimed}">mdi-ticket</v-icon>
                            </v-btn>
                            <div>
                                <span v-if="meal(currentWeek, day, meal_type.id).recipe" class="meal-title">{{ meal(currentWeek, day, meal_type.id).recipe.title }}</span>
                                <div v-else-if="meal(currentWeek, day, meal_type.id).meal">
                                    <span class="meal-title">{{ meal(currentWeek, day, meal_type.id).meal.title }}</span>
                                    <ul v-if="meal(currentWeek, day, meal_type.id).meal.ingredient_lists[0]" class="meal-recipe-list">
                                        <li v-for="ingredient in ingredients(meal(currentWeek, day, meal_type.id).meal.ingredient_lists[0].ingredients)">
                                            <recipe-ingredient :ingredient="ingredient" :inline="true" :inapp="true"></recipe-ingredient>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <router-link v-if="meal(currentWeek, day, meal_type.id).recipe && !inline" :to="getViewUrl(meal(currentWeek, day, meal_type.id).recipe)" class="view-recipe">View Recipe</router-link>
                            <button v-else-if="meal(currentWeek, day, meal_type.id).recipe && inline" @click="previewRecipe(meal(currentWeek, day, meal_type.id).recipe)" class="view-recipe">View Recipe</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <v-dialog v-if="!inline" :value="token.action" persistent max-width="290">
            <v-card>
                <v-card-title class="headline"><span v-if="token.action == 'add'">Claim Token</span><span v-if="token.action == 'remove'">Disclaim Token</span></v-card-title>
                <v-card-text>Are you sure you want to <span v-if="token.action == 'add'">claim</span><span v-if="token.action == 'remove'">disclaim</span> this meal token?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" text @click="token = {action: null}">Cancel</v-btn>
                    <v-btn color="primary darken-1" text @click="claimToken()"><span v-if="token.action == 'add'">Claim</span><span v-if="token.action == 'remove'">Disclaim</span></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import RecipeIngredient from "./RecipeIngredient";
    import moment from "moment";

    export default {
        name: "MealPlan",
        components: {RecipeIngredient},
        props: ['inline', 'challengeWeek', 'realDay'],
        data () {
            return {

            }
        },
        filters: {
            dayName: function (day, week, currentDay) {

                if(!currentDay) currentDay = moment().day() - 700

                day = (week - 1) * 7 + day

                let diff = day - currentDay


                return moment().add(diff, 'days').calendar(moment(), {
                    sameDay: '[Today]',
                    nextDay: '[Tomorrow]',
                    nextWeek: 'dddd',
                    lastDay: '[Yesterday]',
                    lastWeek: 'dddd',
                    sameElse: 'dddd'
                })
            }
        },
        computed: {
            ...mapGetters('MealPlan', ['challenge', 'meal_plan_items', 'weeks', 'meal_types', 'meal', 'day_nutrition', 'meal_nutrition', 'meal_tokens', 'snack_tokens']),
            ...mapGetters('Recipe', ['recipe']),
            ...mapGetters('Streams', ['stream']),
            ...mapGetters('Settings', ['imageUrl']),
            currentDay () {
                if(!this.inline) return this.$store.getters['challenge/currentDay']
                return null
            },
            currentWeek: {
                get() {
                    return this.$store.getters['MealPlan/currentWeek']
                },
                set(newValue) {
                    return this.$store.dispatch('MealPlan/setCurrentWeek', newValue)
                }
            },
            token: {
                get() {
                    return this.$store.getters['MealPlan/token']
                },
                set(newValue) {
                    return this.$store.dispatch('MealPlan/setToken', newValue)
                }
            }
        },
        methods: {
            claimToken () {
                let item = this.token.item
                let action = this.token.action
                this.token = {action: null}
                this.$store.dispatch('nutrition/updateMealToken', {item, action})
            },
            cantClaimToken (meal) {
                if (this.challengeWeek !== this.currentWeek) return true
                switch (meal.meal_type.token_type) {
                    case 'meal':
                        if (!meal.claimed && this.meal_tokens.length >= 2) return true
                        else return false
                    case 'snack':
                        if (!meal.claimed && this.snack_tokens.length >= 2) return true
                        else return false
                }
                return false
            },
            updateMealToken (meal_plan_item) {
                this.token.item = meal_plan_item
                this.token.action = meal_plan_item.claimed ? 'remove' : 'add'
            },
            ingredients (ingredients) {
                var that = this
                var return_ingredients = []
                ingredients.forEach(ingredient => {
                    if(!that.stream) return
                    if(ingredient.stream > 0 && parseInt(ingredient.stream) !== parseInt(that.stream.id)) return
                    if(parseInt(that.stream.id) > 0 && ingredient.stream === 0 && return_ingredients[ingredient.position]) return
                    return_ingredients[ingredient.position] = ingredient
                })

                return return_ingredients
            },
            previewRecipe (recipe) {
                this.$store.dispatch('Recipe/previewRecipe', recipe.id)
            },
            getViewUrl(recipe) {
              if(this.inline) {
                return '/meal-plan/preview/' + this.challenge.id + '/recipe/' + recipe.id + (recipe.global_region ? '/' + recipe.global_region.id : '')
              } else {
                return '/recipe/' + recipe.slug + (recipe.global_region ? '/' + recipe.global_region.id : '')
              }
            },
            getMealIcon(meal_type) {
                switch (meal_type.title) {
                    default:
                        return require('./assets/icons/meal-icon-generic.svg')
                    case 'Breakfast':
                        return require('./assets/icons/meal-icon-breakfast.svg')
                    case 'Morning Snack':
                    case 'Afternoon Snack':
                        return require('./assets/icons/meal-icon-snack.svg')
                    case 'Lunch':
                        return require('./assets/icons/meal-icon-lunch.svg')
                    case 'Dinner':
                        return require('./assets/icons/meal-icon-dinner.svg')
                    case 'Late Evening Snack':
                        return require('./assets/icons/meal-icon-dessert.svg')
                }
            }
        }
    }
</script>

<style lang="scss">
    // flex align to the top on blank layout
    @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500&display=swap');
    body.body__recipe {
        align-items: start !important;
    }
    #mealplan-container {
        all: initial !important; // reset everything so no other styles effect
        font-size: 18px !important;
        text-rendering: optimizeLegibility !important;
        -webkit-font-smoothing: antialiased !important;
        // start styling
        header {
            all: initial;
        }
        .mealplan-day {
            font-family:"DIN Alternate Bold", Roboto, sans-serif;
            h5 {
                font-family: "DIN Condensed Bold", "Arial", sans-serif;
                background-color:#24adbb;
                margin-bottom:0;
                color:#fff;
                text-align:center;
                text-transform:uppercase;
                font-size:1.1em;
                line-height: 200%;
                height: 30px;
            }
            .sticky {
                width:100%;
                position:sticky;
                top:123px;
                &.inline {
                  top:0px;
                  h5 {
                    line-height: 1.5;
                  }
                }
                z-index:1;
                .nutrition-info {
                    font-family: "DIN Condensed Bold", "Arial", sans-serif;
                    display:flex;
                    flex-wrap:wrap;
                    justify-content:space-evenly;
                    background-color:#eee;
                    border-bottom:1px solid #ddd;
                    font-size:.8em;
                    box-shadow:0 5px 10px 0px rgba(0, 0, 0, 0.2);
                    .nutrition-results {
                        margin:.4em;
                        padding:.3em 0 .3em 0;
                        p {
                            margin-bottom:0;
                        }
                        span {
                            color:#222;
                            font-size:1.3em;
                            &:nth-child(2) {
                                color:#888;
                                text-transform: uppercase;
                                font-size:1.1em;
                                margin-left: 5px;
                            }
                        }
                    }
                }
            }
            .meal {
                display:flex;
                flex-wrap:wrap;
                border-bottom:1px solid #ddd;
                padding:0.8em 0 1em 0;
                .meal-image {
                    margin: 0 30px 0 10px;
                    img {
                        margin:0.5em 0 0 1em;
                        width:50px;
                        height:50px;
                        object-fit:cover;
                        border-radius:50%;
                        box-shadow: 0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12) !important;
                    }
                }
                .meal-details {
                    font-family:Roboto,sans-serif;
                    flex:3;
                    padding: 0.5em .5em 0.2em 0;
                    .meal-name {
                        display:flex;
                        align-items:center;
                        h6 {
                            font-family:Roboto,sans-serif;
                            text-transform:uppercase;
                            color:#24adbb;
                            font-weight:bold;
                            flex:2;
                            margin-bottom:0;
                            font-size: 1em;
                        }
                        button {
                            border:0;
                            width:30px;
                            height:30px;
                            margin-right:1em;
                            background:0;
                            background-color:#24adbb;
                            border-radius:50%;
                            color:#fff;
                            font-size:1em;
                            box-shadow:0 6px 8px 1px rgba(0, 0, 0, 0.2);
                            .token {
                                text-align:right;
                                flex:1;
                            }
                        }
                    }
                    .meal-description {
                        ul.meal-recipe-list {
                            padding: 0;
                            font-size: 14px;
                            color: #999;
                            list-style: none;
                            margin-bottom: 0;
                            li {

                            }
                        }
                        span.meal-title {
                            display: block;
                            font-size:.8em;
                            width:80%;
                            line-height:1.5em;
                            font-weight:300;
                            margin: 7px 0;
                        }
                        .view-recipe {
                            border: none;
                            font-size:.8em;
                            padding:5px;
                            text-transform:uppercase;
                            text-decoration: none;
                            border-radius:2px;
                            background-color:#24adbb;
                            color:#fff;
                            box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12);
                        }
                    }
                }
            }
        }
    }
</style>
